var utils = require('lib/utils');
var Model = Chaplin.Model.extend({
	//options: {
	//	headers: {
	//		/*
	//		 * Set the 'Authorization' header and get the access
	//		 * token from the `auth` module
	//		 */
	//		'Authorization': 'Bearer ' + utils.getCookie('access_token')
	//	}
	//},
	//sync: function (method, model, options) {
	//	var backboneSync = Backbone.Sync;
	//
	//	options.headers = this.options.headers;
	//
	//	return Backbone.sync.apply(this, [method, model, options]);
	//}
  // Mixin a synchronization state machine.
  initialize: function() {
	  _.extend(this, Backbone.Validation.mixin);
     _.extend(this, Chaplin.SyncMachine);
     //Model.prototype.apply(this, arguments);
     //this.on('request', this.beginSync);
     //this.on('sync', this.finishSync);
     this.on('error', this.onErr);
  },
	onErr: function (context, e) {

		if (e.status == 401) {
			//Chaplin.utils.redirectTo('quote#dashboard');
			window.location.href = '/index.php/login';
		}
	}

  // Place your application-specific model features here
});

module.exports = Model;
